<template>
  <TitleBox :titleBgColor="titleBgColor" :bgColor="getBgColor()" :class="getClass()">
    <template v-slot:title>
      {{$store.getters.language.texts.Instruction_CommonName}}
    </template>
    <template v-slot:body>
      <div v-if="index > 1" class="lxn-w10" style="float: left"  @click="deleteCondition(index)">
        <ButtonIcon :size="20" bgColor="#f76b48" icon="trash" iconColor="#ffffff" :padding="3" borderColor="#f6af9d" :onclickEffect="true" />
      </div>
      <div class="AddScenario-wrapper-name-text AddScenario-wrapper-padding-0 lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
        {{$store.getters.language.texts.AddScenario_text8}}
      </div>
      <div class="lxn-w100">
        <DropDown v-model="type" :dropDownContex="dropDownTargetType" />
      </div>
      <div v-if="type === CONFIGS.INSTRUCTION_CONDITION_TYPE.SINGLESHOT" class="lxn-w100">
        <div class="CommandCreator-wrapper-fieldTitles lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
          {{$store.getters.language.texts.CommandCreator_text7}}
        </div>
        <div class="lxn-w100">
          <customInput v-model="date" bgColor="#FFFFFF" :placeHolder="$store.getters.language.texts.AddSchedule_datePlaceHolder" inputType="text" />
        </div>
      </div>
      <div v-if="type === CONFIGS.INSTRUCTION_CONDITION_TYPE.SINGLESHOT || type === CONFIGS.INSTRUCTION_CONDITION_TYPE.WEEKLY" :class="$store.getters.language.directionClass" style="display:flex;flex-wrap: nowrap; justify-content: space-between; gap:10px">
        <div style="flex-grow: 1;">
          <div class="AddSchedule-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
            {{$store.getters.language.texts.AddSchedule_text3}}
          </div>
          <div class="lxn-w100 lxn-overflow-hidden">
            <NumberInputSpinner :min="0" :max="23" :step="1" :integerOnly="true" v-model="hour" buttonClass="AddSchedule-commandDelay-button" :twoDigitsOnly="true" />
          </div>
        </div>
        <div style="flex-grow: 1;">
          <div class="AddSchedule-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
            {{$store.getters.language.texts.AddSchedule_text4}}
          </div>
          <div class="lxn-w100 lxn-overflow-hidden">
            <NumberInputSpinner :min="0" :max="59" :step="1" :integerOnly="true" v-model="minute" buttonClass="AddSchedule-commandDelay-button" :twoDigitsOnly="true" />
          </div>
        </div>
      </div>
      <div v-if="type === CONFIGS.INSTRUCTION_CONDITION_TYPE.WEEKLY" class="lxn-w100 lxn-margin-top-5">
        <div class="AddSchedule-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
          {{$store.getters.language.texts.AddSchedule_text5}}
        </div>
        <div class="lxn-w100 lxn-overflow-hidden">
          <div @click="daySelected(6)" class="AddSchedule-days lxn-float-right lxn-border-round lxn-text-center lxn-cursor-pointer" :class="[repeatDaysSelected(6), $store.getters.language.font, $store.getters.language.directionClass]">
            {{$store.getters.language.texts.weekDaysShort[6]}}
          </div>
          <div @click="daySelected(0)" class="AddSchedule-days lxn-float-right lxn-border-round lxn-text-center lxn-cursor-pointer" :class="[repeatDaysSelected(0), $store.getters.language.font, $store.getters.language.directionClass]">
            {{$store.getters.language.texts.weekDaysShort[0]}}
          </div>
          <div @click="daySelected(1)" class="AddSchedule-days lxn-float-right lxn-border-round lxn-text-center lxn-cursor-pointer" :class="[repeatDaysSelected(1), $store.getters.language.font, $store.getters.language.directionClass]">
            {{$store.getters.language.texts.weekDaysShort[1]}}
          </div>
          <div @click="daySelected(2)" class="AddSchedule-days lxn-float-right lxn-border-round lxn-text-center lxn-cursor-pointer" :class="[repeatDaysSelected(2), $store.getters.language.font, $store.getters.language.directionClass]">
            {{$store.getters.language.texts.weekDaysShort[2]}}
          </div>
          <div @click="daySelected(3)" class="AddSchedule-days lxn-float-right lxn-border-round lxn-text-center lxn-cursor-pointer" :class="[repeatDaysSelected(3), $store.getters.language.font, $store.getters.language.directionClass]">
            {{$store.getters.language.texts.weekDaysShort[3]}}
          </div>
          <div @click="daySelected(4)" class="AddSchedule-days lxn-float-right lxn-border-round lxn-text-center lxn-cursor-pointer" :class="[repeatDaysSelected(4), $store.getters.language.font, $store.getters.language.directionClass]">
            {{$store.getters.language.texts.weekDaysShort[4]}}
          </div>
          <div @click="daySelected(5)" class="AddSchedule-days lxn-float-right lxn-border-round lxn-text-center lxn-cursor-pointer" :class="[repeatDaysSelected(5), $store.getters.language.font, $store.getters.language.directionClass]">
            {{$store.getters.language.texts.weekDaysShort[5]}}
          </div>
        </div>
      </div>
      <div v-if="type === CONFIGS.INSTRUCTION_CONDITION_TYPE.OUTPUT" class="lxn-w100">
        <div class="CommandCreator-wrapper-fieldTitles lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
          {{$store.getters.language.texts.CommandCreator_text2}}
        </div>
        <div class="lxn-w100">
          <DropDown v-model="targetOutput" :dropDownContex="dropDownTargetOutputs" />
        </div>
        <div class="CommandCreator-wrapper-fieldTitles lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
          {{$store.getters.language.texts.CommandCreator_text11}}
        </div>
        <div class="CommandCreator-wrapper-fieldTitles lxn-w100">
          <div class="lxn-display-table lxn-margin-auto">
            <SingleSwitch @switchClicked="toggleSwitchState()" :state="switchState" bgColorOn="#00AEEF" bgColorOff="#ACB8BF" bgColorPending="#CCCCCC" handleColorOn="#FFFFFF" handleColorOff="#FFFFFF" />
          </div>
        </div>
      </div>
      <div v-if="type === CONFIGS.INSTRUCTION_CONDITION_TYPE.SINGLESHOT || type === CONFIGS.INSTRUCTION_CONDITION_TYPE.WEEKLY" class="lxn-w100 lxn-margin-top-5">
        <div class="CommandCreator-wrapper-fieldTitles lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
          {{$store.getters.language.texts.CommandCreator_text6}}
        </div>
        <div class="lxn-w100 lxn-overflow-hidden">
          <NumberInputSpinner :min="0" :max="65535" :step="1" :integerOnly="true" v-model="duration" buttonClass="CommandCreator-commandDelay-button" />
        </div>
      </div>
      <div v-if="type === CONFIGS.INSTRUCTION_CONDITION_TYPE.PERIODIC" :class="$store.getters.language.directionClass" style="display:flex;flex-wrap: nowrap; justify-content: space-between; gap:10px">
        <div style="flex-grow: 1;">
          <div class="AddSchedule-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
            {{$store.getters.language.texts.AddSchedule_text15}}
          </div>
          <div class="lxn-w100 lxn-overflow-hidden">
            <NumberInputSpinner :min="0" :max="65535" :step="1" :integerOnly="true" v-model="onDuration" buttonClass="AddSchedule-commandDelay-button" />
          </div>
        </div>
        <div style="flex-grow: 1;">
          <div class="AddSchedule-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
            {{$store.getters.language.texts.AddSchedule_text16}}
          </div>
          <div class="lxn-w100 lxn-overflow-hidden">
            <NumberInputSpinner :min="0" :max="65535" :step="1" :integerOnly="true" v-model="offDuration" buttonClass="AddSchedule-commandDelay-button" />
          </div>
        </div>
      </div>
      <div v-if="conditions.length > 0" class="lxn-w100 lxn-margin-top-20">
        <InstructionCondition v-for="(con, index) in conditions" ref="conditions" :titleBgColor="titleBgColor" :condition="con" :key="index" :index="index" :targetHub="targetHub" :bgColor="getBgColorData()" :deleteCondition="deleteThisCondition"></InstructionCondition>
      </div>
      <div v-if="showAdd()" class="lxn-margin-auto lxn-margin-top-20 lxn-w100 lxn-display-flex-center"  @click="addCondition">
        <ButtonIcon :size="30" bgColor="#1EA5DE" icon="plus" iconColor="#ffffff" :padding="10" borderColor="#f6af9d" :onclickEffect="true" />
      </div>
      <slot name="commands">
      </slot>
    </template>
  </TitleBox>
</template>

<script>
import CommandCreator from '@/components/CommandCreator.vue'
import TitleBox from '@/components/TitleBox.vue'
import CustomInput from '@/components/CustomInput.vue'
import DropDown from '@/components/DropDown.vue'
import * as CONFIGS from '@/statics/configs.js'
import CustomButton from '@/components/CustomButton.vue'
import ButtonIcon from "@/components/ButtonIcon";
import NumberInputSpinner from '@/components/NumberInputSpinner.vue'
import Vue from "vue";
import SingleSwitch from "@/components/SingleSwitch";
import * as moment from "jalali-moment";
import Messaging from "@/statics/messaging";
import Logger from "@/statics/logger";

const messaging = new Messaging(new Logger(false));

export default {
  name: 'InstructionCondition',
  props: {
    index: Number,
    titleBgColor: String,
    className: String,
    condition: Object,
    bgColor: String,
    deleteCondition: Function,
    targetHub: Number,
    types: [],
  },
  components: {
    TitleBox,
    CustomButton,
    CustomInput,
    ButtonIcon,
    NumberInputSpinner,
    DropDown,
    CommandCreator,
    SingleSwitch
  },
  data: function () {
    return {
      conditions: this.condition.conditions,
      type: this.condition.type,
      bgColorData: this.bgColor,
      CONFIGS,
      date: new Date().toLocaleDateString('fa-IR-u-nu-latn'),
      hour: new Date().getHours(),
      minute: new Date().getMinutes(),
      endHour: new Date().getHours(),
      endMinute: new Date().getMinutes(),
      onDuration: 0,
      offDuration: 0,
      repeatDays: [false, false, false, false, false, false, false],
      duration: 0,
      generatedCommandInput: [],
      generatedCommandOutput: [],
      generatedCommandInputData: [],
      generatedCommandOutputData: [],
      targetOutput: 0,
      switchState: 'on',
    }
  },
  mounted: function () {
  },
  watch: {
    'type': function () {
      this.conditions = [];
      if (this.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.AND || this.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.OR){
        this.conditions = [{type: 0, conditions: []}, {type: 0, conditions: []}];
      }
    }
  },
  computed: {
    dropDownTargetType: function () {
      return {
        name: "AddScenario-TargetType",
        title: this.$store.getters.language.texts.AddScenario_text7,
        selectedIndex: this.type,
        data: [
          {
            name: this.$store.getters.language.texts.AddScenario_select,
            icon: 'arrowLeft',
          },
          {
            name: this.$store.getters.language.texts.AddScenario_and,
            value: this.types === undefined || this.types.includes(CONFIGS.INSTRUCTION_CONDITION_TYPE.AND) ? CONFIGS.INSTRUCTION_CONDITION_TYPE.AND : -1,
            icon: 'arrowLeft',
          },
          {
            name: this.$store.getters.language.texts.AddScenario_or,
            value: this.types === undefined || this.types.includes(CONFIGS.INSTRUCTION_CONDITION_TYPE.OR) ? CONFIGS.INSTRUCTION_CONDITION_TYPE.OR : -1,
            icon: 'arrowLeft',
          },
          {
            name: this.$store.getters.language.texts.AddScenario_parameter,
            value: this.types === undefined || this.types.includes(CONFIGS.INSTRUCTION_CONDITION_TYPE.OUTPUT) ? CONFIGS.INSTRUCTION_CONDITION_TYPE.OUTPUT : -1,
            icon: 'arrowLeft',
          },
          {
            name: this.$store.getters.language.texts.AddScenario_single,
            value: this.types === undefined || this.types.includes(CONFIGS.INSTRUCTION_CONDITION_TYPE.SINGLESHOT) ? CONFIGS.INSTRUCTION_CONDITION_TYPE.SINGLESHOT : -1,
            icon: 'arrowLeft',
          },
          {
            name: this.$store.getters.language.texts.AddScenario_weekly,
            value: this.types === undefined || this.types.includes(CONFIGS.INSTRUCTION_CONDITION_TYPE.WEEKLY) ? CONFIGS.INSTRUCTION_CONDITION_TYPE.WEEKLY : -1,
            icon: 'arrowLeft',
          },
          {
            name: this.$store.getters.language.texts.AddScenario_periodic,
            value: this.types === undefined || this.types.includes(CONFIGS.INSTRUCTION_CONDITION_TYPE.PERIODIC) ? CONFIGS.INSTRUCTION_CONDITION_TYPE.PERIODIC : -1,
            icon: 'arrowLeft',
          },
          {
            name: this.$store.getters.language.texts.AddScenario_onenter,
            value: this.types === undefined || this.types.includes(CONFIGS.INSTRUCTION_CONDITION_TYPE.ONENTER) ? CONFIGS.INSTRUCTION_CONDITION_TYPE.ONENTER : -1,
            icon: 'arrowLeft',
          },
          {
            name: this.$store.getters.language.texts.AddScenario_onexit,
            value: this.types === undefined || this.types.includes(CONFIGS.INSTRUCTION_CONDITION_TYPE.ONEXIT) ? CONFIGS.INSTRUCTION_CONDITION_TYPE.ONEXIT : -1,
            icon: 'arrowLeft',
          }
        ]
      };
    },

    dropDownTargetOutputs: function () {
      var dropDownTargetOutputs = {
        name: "Scenario-TargetOutputs",
        title: this.$store.getters.language.texts.CommandCreator_text2,
        selectedIndex: this.targetOutput,
        data: []
      };
      for(var i = 0; i < this.$store.state.nodes.length; i++){
        if(this.$store.state.hubs[this.targetHub].uuid === this.$store.state.nodes[i].hubUUID){
          for(var j = 0; j < this.$store.state.nodes[i].outputs.length; j++){
            dropDownTargetOutputs.data.push({
              name: this.$store.state.nodes[i].name + ' > ' + this.$store.state.nodes[i].outputs[j].name,
              icon: this.$store.state.nodes[i].outputs[j].icon,
              data: {
                node: this.$store.state.nodes[i],
                output: this.$store.state.nodes[i].outputs[j],
                outputIndex: j
              }
            })
          }
        }
      }
      for(var i = 0; i < this.$store.state.nodes.length; i++){
        if(this.$store.state.hubs[this.targetHub].uuid === this.$store.state.nodes[i].hubUUID){
          if (this.$store.state.nodes[i].inputs && this.$store.state.nodes[i].inputs.length) {
            for(var j = 0; j < this.$store.state.nodes[i].inputs.length; j++){
              dropDownTargetOutputs.data.push({
                name: this.$store.state.nodes[i].name + ' > ' + this.$store.state.nodes[i].inputs[j].name,
                icon: this.$store.state.nodes[i].inputs[j].icon,
                data: {
                  node: this.$store.state.nodes[i],
                  output: this.$store.state.nodes[i].inputs[j],
                  inputIndex: j
                }
              })
            }
          }
        }
      }
      this.$store.state.hubs.map(x => [...(x.outputs?.internal || []).map(i => {
        return {
          node: {uuid: x.uuid, name: x.name},
          output: {parameterId: i.parameterId, name: i.name, type: "internal"},
        };
      }), ...(x.outputs?.expansion1 || []).map(i => {
        return {
          node: {uuid: x.uuid, name: x.name},
          output: {parameterId: i.parameterId, name: i.name, type: "internal"},
        };
      }), ...(x.outputs?.expansion2 || []).map(i => {
        return {
          node: {uuid: x.uuid, name: x.name},
          output: {parameterId: i.parameterId, name: i.name, type: "internal"},
        };
      })]).flatMap(x => x).forEach((x, j) => {
        dropDownTargetOutputs.data.push({
          name: x.node.name + ' > ' + x.output.name,
          icon: "hub",
          data: {
            node: x.node,
            output: x.output,
            outputIndex: j,
          }
        })
      });
      return dropDownTargetOutputs;
    },
  },
  methods: {
    getHourMinuteFromTimeStamp(timeStamp) {
      const totalMinutes = Math.floor(timeStamp / 60000);
      const hour = Math.floor(totalMinutes / 60);
      const minute = totalMinutes % 60;
      const HH = String(hour).padStart(2, '0');
      const mm = String(minute).padStart(2, '0');
      return {hour: HH, minute: mm};
    },
    getDateTimeFromStamp(dateStamp, timeStamp) {
      const epochTime = dateStamp * 86400000 + timeStamp;
      const m = moment(epochTime).locale('fa');
      return {
        date: m.format('YYYY/MM/DD'),
        hour: m.format('HH'),
        minute: m.format('mm'),
      };
    },
    numberToBooleanList(num) {
      const binaryStr = num.toString(2);
      const res = [...binaryStr].map(bit => bit === '1');
      return [res[1], res[2], res[3], res[4], res[5], res[6], res[0]];
    },
    getDateTimeStamp(date, hour, minute)
    {
      const epochTime = moment.from(date + ' ' + hour + ':' + minute, 'fa', 'YYYY/MM/DD HH:mm').locale('en').valueOf();
      var dateStamp = Math.floor(epochTime / 86400000);
      var timeStamp = epochTime % 86400000;
      return {date: dateStamp, time: timeStamp};
    },
    getTimeStamp(hour, minute)
    {
      return (hour * 60 + minute) * 60000;
    },
    getRepeatMask()
    {
      return Number(`0b0${this.repeatDays[6] ? 1 : 0}${this.repeatDays[0] ? 1 : 0}${this.repeatDays[1] ? 1 : 0}${this.repeatDays[2] ? 1 : 0}${this.repeatDays[3] ? 1 : 0}${this.repeatDays[4] ? 1 : 0}${this.repeatDays[5] ? 1 : 0}`);
    },
    checkData: function () {
      if (this.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.NONE){
        alert(this.$store.getters.language.texts.AddScenario_alert2);
        return false;
      } else if (this.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.WEEKLY){
        if (this.getRepeatMask() === 0){
          alert(this.$store.getters.language.texts.AddScenario_alert3);
          return ;
        }
      } else if (this.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.PERIODIC){
        if (this.onDuration === 0 || this.offDuration === 0){
          alert(this.$store.getters.language.texts.AddScenario_alert4);
          return false;
        }
      } else if (this.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.AND || this.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.OR){
        return this.$refs.conditions.every(x => x.checkData());
      }
      if (this.generatedCommandInput.length <= 0){
        alert(this.$store.getters.language.texts.AddScenario_alert5);
        return false;
      }
      return true;
    },
    setData: function (condition) {
      console.log('@@@@@@@@', condition)
      this.type = condition.type;
      if (this.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.OUTPUT){
        this.targetOutput = this.dropDownTargetOutputs.data.findIndex(x => x.data.output.parameterId === condition.output.parameterId);
        this.switchState = condition.output.referenceValue === 1 ? 'on' : 'off';
      } else if (this.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.SINGLESHOT){
        const datetime = this.getDateTimeFromStamp(condition.singleShot.date, condition.singleShot.time);
        this.date = datetime.date;
        this.hour = parseInt(datetime.hour);
        this.minute = parseInt(datetime.minute);
        this.duration = condition.singleShot.duration / 1000;
      } else if (this.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.WEEKLY){
        const dt = this.getHourMinuteFromTimeStamp(condition.weekly.time);
        this.hour = parseInt(dt.hour);
        this.minute = parseInt(dt.minute);
        this.duration = condition.weekly.duration / 1000;
        this.repeatDays = this.numberToBooleanList(condition.weekly.repeatMask);
      } else if (this.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.PERIODIC){
        this.onDuration = condition.periodic.on / 1000;
        this.offDuration = condition.periodic.off / 1000;
      } else if (this.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.AND || this.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.OR){
        setTimeout(() => {
          this.$refs.conditions.map((x, index) => x.setData(condition.conditions[index]))
        })

      }
    },
    getData: function () {
      return {
        conditions: this.$refs.conditions ? this.$refs.conditions.map(x => x.getData()) : [],
        type: this.type,
        output: this.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.OUTPUT ? {
          parameterId: this.dropDownTargetOutputs.data[this.targetOutput].data.output.parameterId,
          deviceUUID: this.dropDownTargetOutputs.data[this.targetOutput].data.node.uuid,
          referenceValue: this.switchState === 'on' ? 1 : 0,
          relation: CONFIGS.RELATION_EQUAL,
        } : null,
        singleShot: this.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.SINGLESHOT ? {
          ...this.getDateTimeStamp(this.date, this.hour, this.minute),
          duration: this.duration * 1000
        } : null,
        weekly: this.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.WEEKLY ? {
          repeatMask: this.getRepeatMask(),
          time: this.getTimeStamp(this.hour, this.minute),
          duration: this.duration * 1000
        } : null,
        periodic: this.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.PERIODIC ? {
          on: this.onDuration * 1000,
          off: this.offDuration * 1000
        } : null
      };
    },
    toggleSwitchState: function () {
      if(this.switchState === 'on'){
        this.switchState = 'off';
      }else{
        this.switchState = 'on';
      }
    },
    getClass: function () {
      return this.className;
    },
    repeatDaysSelected: function (index) {
      if(this.repeatDays[index] === true){
        return 'active';
      }else{
        return '';
      }
    },
    daySelected: function (index) {
      const newVal = !this.repeatDays[index];
      Vue.set(this.repeatDays, index, newVal);
    },
    getBgColor: function () {
      return this.bgColorData;
    },
    getBgColorData: function () {
      return this.bgColorData === '#D8D8D8' ? '#ECECEC' : '#D8D8D8';
    },
    deleteThisCondition: function (idx) {
      this.conditions.splice(idx, 1);
    },
    addCondition: function () {
      if (this.conditions){
        this.conditions.push({type: 0, conditions: []})
      } else {
        this.conditions = [{type: 0, conditions: []}];
      }
      this.$forceUpdate();
    },
    showAdd: function () {
      return this.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.AND || this.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.OR
    },
  }
}
</script>

<style>
  .AddScenario-wrapper-name-text {
    height: 50px;
    padding-top: 20px;
    line-height: 30px;
    color: #52626C;
  }
  .AddScenario-wrapper-padding-0 {
    padding: 0;
    height: unset;
  }
  .AddSchedule-commandDelay-button {
    -webkit-appearance: none;
    transition: opacity 0.5s ease;
    background: #1EA5DE;
    border: 0;
    border-radius: 7px;
    overflow: hidden;
    color: #fff;
    cursor: pointer;
    float: left;
    font-size: 20px;
    height: 40px;
    margin: 0;
    width: 40px;
  }
  .AddSchedule-commandDelay-button:hover {
    opacity: 0.5;
  }
  .AddSchedule-commandDelay-button:hover {
    opacity: 0.5;
  }
  .AddSchedule-commandDelay-button:focus {
    outline: 0;
    outline-offset: 0;
  }
  .AddSchedule-days {
    width: calc(100% / 7 - 4px);
    height: 40px;
    margin-right: 2px;
    margin-left: 2px;
    line-height: 40px;
    background-color: #53636C;
    color: #FFFFFF;
  }
  .AddSchedule-days.AddSchedule-days-mini {
    height: 18px;
    margin-right: 1px;
    margin-left: 1px;
    font-size: 10px;
    line-height: 18px;
  }
  .AddSchedule-days.active {
    background-color: #1EA5DE;
  }
</style>
